// Форматирование суммы в копейках в строку.
// Совпадает с серверным cur_formatter (хелпер): копейки / 100 со
// своим separator и nbsp как разделитель тысяч.
export function curFormat(amount, opts) {
  const o = opts || {};
  const value = (amount || 0) / 100;
  const sep = o.separator || ',';
  const groupSep = o.group || ' ';
  const sign = value < 0 ? '-' : '';
  const abs = Math.abs(value);
  const fixed = Number(abs).toFixed(2);
  const [intPart, fracPart] = fixed.split('.');
  const intGrouped = intPart.replace(/\B(?=(\d{3})+(?!\d))/g, groupSep);
  const frac = (fracPart || '00') === '00' ? '' : `${sep}${fracPart}`;
  return `${sign}${intGrouped}${frac}`;
}

// Дата доставки в 'DD.MM.YYYY'. Повторяет formatDate из клиентского
// приложения (client_app/src/helpers/functions/index.ts): сервер отдаёт
// MobileOrderSerializer#date как delivery_datetime.to_date, т.е. ISO
// 'YYYY-MM-DD', и форматируется она на клиенте.
// Уже отформатированную 'DD.MM.YYYY' возвращаем как есть,
// пустое/невалидное — пустой строкой.
export function dateFormat(value) {
  if (!value) return '';
  if (typeof value === 'string' && /^\d{2}\.\d{2}\.\d{4}$/.test(value)) return value;
  // 'YYYY-MM-DD' разбираем строкой: new Date('2026-08-25') — это UTC-полночь,
  // и в минусовых зонах дата уехала бы на день назад.
  const iso = typeof value === 'string' && value.match(/^(\d{4})-(\d{2})-(\d{2})/);
  if (iso) return `${iso[3]}.${iso[2]}.${iso[1]}`;
  const date = value instanceof Date ? value : new Date(value);
  if (isNaN(date.getTime())) return '';
  const pad = (n) => (n < 10 ? `0${n}` : `${n}`);
  return `${pad(date.getDate())}.${pad(date.getMonth() + 1)}.${date.getFullYear()}`;
}

// Дата и интервал доставки одной строкой: 'DD.MM.YYYY, HH:MM - HH:MM'.
// Интервал показываем, только если сервер прислал ОБЕ границы
// (time_from/time_to); нет даты — остаётся один интервал, нет ничего — ''.
export function deliveryWhen(order) {
  const o = order || {};
  const date = dateFormat(o.date);
  const gap = o.time_from && o.time_to ? `${o.time_from} - ${o.time_to}` : '';
  if (date && gap) return `${date}, ${gap}`;
  return date || gap;
}



// WEBPACK FOOTER //
// ./app/javascript/website_newgen/js/shared/format.js